import React, { useState, useEffect } from "react";
import axios from "../../AxiosClient";
import { useTranslation } from "react-i18next";
import { Tabs, Tab } from "@material-ui/core";
import AddIcon from "@material-ui/icons/Add";
import { makeStyles } from "@material-ui/core/styles";
import Tooltip from "@material-ui/core/Tooltip";
import CreateNewCronSchedule from "./CreateNewCronSchedule";
import KnowledgeSourceCronSchedule from "./KnowledgeSourceCronSchedule";
import CreateCronExpression from "./CreateCronExpression";
const useStyles = makeStyles((theme) => ({
  container: {
    overflow: "auto",
    padding: 20,
    height: "100%",
    flex: 1,
    backgroundColor: "#eae0d7",
    backgroundImage: "url('../../images/background.svg')",
  },
  body: {
    display: "flex",
    height: "100%",
    backgroundColor: "#fff",
  },
  tabs: {
    borderRight: `1px solid ${theme.palette.divider}`,
  },
  configContainer: {
    padding: 20,
    width: "100%",
    overflow: "auto",
  },
  tab: {
    textTransform: "none",
  },
}));

function ManageBatchReindexing() {
  const [selectedTab, setSelectedTab] = useState("default");
  const [schedules, setSchedules] = useState([]);
  const { t } = useTranslation();
  const classes = useStyles();
  const [createCronExpressionOpen, setCreateCronExpressionOpen] = useState(
    false
  );
  const [cronExpression, setCronExpression] = useState("");
  const [cronExpressionString, setCronExpressionString] = useState("");

  useEffect(() => {
    axios.get("/knowledgesource/batchreindex/",{ withCredentials:true }).then((res) => {
      setSchedules(res.data.content);
    });
  }, []);

  const getData = () => {
    axios.get("/knowledgesource/batchreindex/",{ withCredentials:true }).then((res) => {
      setSchedules(res.data.content);
    });
  };

  const updateValues = (newData) => {
    let dataCopy = [...schedules];
    dataCopy.map((item, idx) => {
      if (item.scheduleId === newData.scheduleId) {
        dataCopy[idx] = newData;
      }
    });
    setSchedules(dataCopy);
  };

  return (
    <div className={classes.container}>
      <div className={classes.body}>
        <Tabs
          value={selectedTab}
          onChange={(_e, nv) => setSelectedTab(nv)}
          orientation="vertical"
          variant="scrollable"
          className={classes.tabs}
        >
          <Tab
            id="general-settings"
            className={classes.tab}
            label={t("global_default")}
            value="default"
          />
          {schedules.map((schedule, idx) => {
            return (
              <Tab value={schedule.scheduleId} label={schedule.scheduleName} />
            );
          })}
          <Tooltip title={t("create_new_schedule")}>
            <Tab
              id="general-settings"
              className={classes.tab}
              icon={<AddIcon />}
              value="create-new"
            />
          </Tooltip>
        </Tabs>
        <div className={classes.configContainer}>
          {selectedTab === "create-new" && (
            <CreateNewCronSchedule
              cronExpression={cronExpression}
              cronExpressionString={cronExpressionString}
              updateList={getData}
              openCron={() => setCreateCronExpressionOpen(true)}
            />
          )}
          {selectedTab === "default" && <KnowledgeSourceCronSchedule default />}
          {selectedTab !== "default" &&
            (selectedTab !== "create-new" &&
              schedules.map((schedule, idx) => {
                return (
                  <>
                    {selectedTab === schedule.scheduleId && (
                      <KnowledgeSourceCronSchedule
                        updateValues={updateValues}
                        scheduleId={selectedTab}
                        updateList={getData}
                      />
                    )}
                  </>
                );
              }))}
        </div>
      </div>
      <CreateCronExpression
        open={createCronExpressionOpen}
        close={() => setCreateCronExpressionOpen(false)}
        onAccept={(cron, string) => {
          setCronExpression(cron);
          setCronExpressionString(string);
          setCreateCronExpressionOpen(false);
        }}
      />
    </div>
  );
}
export default ManageBatchReindexing;
